const LAYOUT_VIEWPORT_INLINE_SIZE_PROPERTY = "--layout-viewport-inline-size";

let layoutViewportAnimationFrame = null;

const setLayoutViewportInlineSize = () => {
  document.documentElement.style.setProperty(
    LAYOUT_VIEWPORT_INLINE_SIZE_PROPERTY,
    `${document.documentElement.clientWidth}px`
  );
};

const queueLayoutViewportInlineSizeUpdate = () => {
  if (layoutViewportAnimationFrame !== null) return;

  layoutViewportAnimationFrame = requestAnimationFrame(() => {
    layoutViewportAnimationFrame = null;
    setLayoutViewportInlineSize();
  });
};

setLayoutViewportInlineSize();
window.addEventListener("resize", queueLayoutViewportInlineSizeUpdate, { passive: true });
